export default class ScreenshotsTracker {
    constructor() {
        this.trackings = {};
    }

    /**
     * @param {object}              tracking - Options.
     * @param {string}              tracking.screenshot - Screenshot ID.
     * @param {array}               tracking.events - Event names.
     * @param {ScreenshotActions}   tracking.action - Action object.
     * @param {string}              tracking.type - Type string.
     * @return {void}
     * */
    set(tracking) {
        this.screenshot = tracking.screenshot;
        this.events = tracking.events;
        this.action = tracking.action;
        this.type = tracking.type;

        this.trackings[this.type] = this.trackings[this.type] || {};
        this.trackings[this.type][this.screenshot] = this.trackings[this.type][this.screenshot] || {};

        this.events.forEach((event) => {
            this.trackings[this.type][this.screenshot][event] = this.trackings[this.type][this.screenshot][event] || [];
        });

        new this.action(
            this.screenshot,
            this.events,
            this.type,
            this.onAdd.bind(this),
            this.onRemove.bind(this),
            this.onSuccess.bind(this)
        );
    }

    onAdd(screenshot, event, handler, type) {
        window.addEventListener(event, handler);
        this.trackings[type][screenshot][event].push(handler);
    }
    onRemove(screenshot, event, handler, type) {
        window.removeEventListener(event, handler);

        if (type in this.trackings && screenshot in this.trackings[type]) {
            this.trackings[type][screenshot][event].filter((element) => element !== handler);
        }
    }
    onSuccess(screenshot, type) {
        Object.keys(this.trackings[type][screenshot]).forEach((event) => {
            this.trackings[type][screenshot][event].forEach((handler) => {
                window.removeEventListener(event, handler);
            });
        });

        if (type in this.trackings) {
            Object.keys(this.trackings[type]).forEach((screen) => {
                if (type in this.trackings && screen in this.trackings[type]) {
                    Object.keys(this.trackings[type][screen]).forEach((screenEvent) => {
                        this.trackings[type][screen][screenEvent].forEach((screenHandler) => {
                            window.removeEventListener(screenEvent, screenHandler);
                        });
                    });
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/screenshots-tracker.js